
























































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import PlaceJobWorkerOfferRequest from '@/models/JobWorkerOffers/PlaceJobWorkerOfferRequest';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';
import ListUtils from '@/lib/listUtils';

@Component({
    name: 'JobWorkerOfferStatusSetPlaced'
})
export default class extends GiganautVueDialog {
 
  @Prop({required: true})
  jobWorkerOffer: JobWorkerOfferDto;
  request: PlaceJobWorkerOfferRequest = new PlaceJobWorkerOfferRequest();

  get job() {
    return JobDetailsModule.currentJob;
  }

  @Watch("dialog")
  async dialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new PlaceJobWorkerOfferRequest();
    } 
    this.$emit("closeMenu");
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    this.request.jobWorkerOfferId = this.jobWorkerOffer.id;
    this.request.updatedAt = this.jobWorkerOffer.updatedAt;
    await JobDetailsModule.placeJobWorkerOffer(this.request);
    this.dialog = false;
  }
}
